import type { ClientPositionView, WalletVerificationMethod } from "@solomon-apps/shared";

import type { PositionVerificationChallenge } from "./clientPrograms";
import { orgApiFetch } from "./orgApiFetch";

/** Explicit position scope selected by the UI. The server does not expand it. */
export interface PositionDestinationSelection {
    setWalletDefault?: boolean;
    programPositionUuids: string[];
    rewardsDestinationAddress: string;
    signerAddress?: string;
}
export interface EditPositionDestinationsInput extends PositionDestinationSelection {
    verificationMode?: "direct-solomon";
    manualReviewDescription?: string;
    verificationMethod?: WalletVerificationMethod;
    verificationSignature?: string;
    nonce?: string;
    verificationSignedMessage?: string;
}
// The simulator still serves the legacy wallet settings contract.
export interface WalletDistributionSettings {
    uuid: string;
    address: string;
    rewardsDestinationAddress: string | null;
    distributionMode: "stream" | "claim" | null;
    distributionSettingsVersion: number;
    distributionSettingsChangedAt: string | null;
    appliesTo: "future_runs";
}
export function issueRewardsDestinationChallenge(
    positionUuid: string,
    selection: PositionDestinationSelection
): Promise<PositionVerificationChallenge> {
    return orgApiFetch(`/api/org/client/positions/${encodeURIComponent(positionUuid)}/destination-challenge`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(selection)
    });
}
export function editPositionDestinations(
    positionUuid: string,
    input: EditPositionDestinationsInput
): Promise<ClientPositionView> {
    return orgApiFetch(`/api/org/client/positions/${encodeURIComponent(positionUuid)}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input)
    });
}
